<template>
  <form @submit.prevent="sendChat()" novalidate>
    <div>
      <div id="mentionContainer" v-show="mentionSelector">
        <ul>
          <li @click="onMentionClick('Everyone')">Everyone</li>
          <li @click="onMentionClick('Teacher')">Teacher</li>
          <li @click="onMentionClick('Colleague')">Colleague</li>
        </ul>
      </div>
      <div class="text-row">
        <textarea type="text" :placeholder="$t('1203')" v-model="msg" ref="msg" />
      </div>

      <!-- 내용을 입력하세요 -->
      <div class="btn-row">
        <ul>
          <li>
            <button @click="addFiles()" id="btnPhoto" type="button">
              <span class="material-icons mdc-icons">photo_library</span>
            </button>
            <input
              type="file"
              id="files"
              ref="files"
              multiple
              accept="image/*"
              @change="(e) => uploadFile(e, 'CHAT')"
              class="d-none"
            />
          </li>
        </ul>
        <button
          class="mdc-icon-button send-btn"
          id="btnSend"
          type="button"
          @click="sendChat()"
          :class="{ on: isSendBtn }"
          :disabled="!isSendBtn"
        >
          <span class="material-icons mdc-icons">arrow_circle_up</span>
        </button>
      </div>

      <div v-show="isAttachments">
        <div id="photosContainer">
          <!-- <div v-for="(attachment, index) in attachments" :style="attachment.resourceUri ? `background-image: url(${attachment.resourceUri});` : ''"> -->
          <div v-for="(attachment, index) in attachments" :key="index">
            <img :src="attachment.resourceUri" alt="Image" class="img-box" />
            <div class="material-icons-outlined close-btn" @click="deleteAttachment">
              close
            </div>
          </div>
        </div>
      </div>
      <div class="clearfix"></div>
    </div>
  </form>
</template>

<script>
/**
 * 나의학습/시험 질문하기 - 채팅 등록 컴포넌트(my learn / exam question - chatting write component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import httpService from "@/api/httpService.js";
import chatApi from "@/api/chatApi.js";
import { fileMixin } from "@/mixins/file.js";

export default {
  props: ["learnId", "lessonId", "roomId", "examineeId", "questionId"],
  data() {
    return {
      mentionSelector: false,

      msg: "",
      attachments: [],
    };
  },

  mixins: [fileMixin],

  computed: {
    isSendBtn() {
      return !!this.msg || !!this.attachments.length;
    },

    isAttachments() {
      return this.attachments.length;
    },
  },

  mounted() {
    // this.learnId=this.$route.params.learnId
    // this.lessonId=this.$route.params.lessonId
  },

  methods: {
    onMentionClick(target) {
      this.msg += "@" + target + " ";
      this.mentionSelector = !this.mentionSelector;
      this.$refs.msg.focus();
    },

    toggleMentionSelector() {
      this.mentionSelector = !this.mentionSelector;
    },

    sendChat() {
      if (this.$route.meta.chatType === "exam") {
        // for exam question
        this.sendExamChat();
      } else {
        // for my learn
        this.sendLearnChat();
      }
    },

    // regist chat for exam
    sendExamChat() {
      let params = {
        examineeId: this.examineeId,
        questionId: this.questionId,
        roomId: this.roomId > 0 ? this.roomId : null,
        msg: this.msg,
        attachments: this.attachments,
      };
      this.$showLoading();
      chatApi
        .examChatroomChat(params)
        .then((response) => {
          console.log(response);
          this.msg = "";
          this.attachments = [];
          this.$hideLoading();
          this.$emit("updateListData", response.data.data);
        })
        .catch((err) => {});
    },

    // regist chat for my learn
    sendLearnChat() {
      let params = {
        learnId: this.$route.params.learnId,
        lessonId: this.$route.params.lessonId,
        roomId: this.roomId > 0 ? this.roomId : null,
        msg: this.msg,
        attachments: this.attachments,
      };
      this.$showLoading();
      chatApi
        .learnChatroomChat(params)
        .then((response) => {
          this.msg = "";
          this.attachments = [];
          this.$hideLoading();
          this.$emit("updateListData", response.data.data);
        })
        .catch((err) => {});
    },
  },
};
</script>

<style scoped>
.img-box {
  aspect-ratio: 1/1;
  object-fit: cover;
}
.mdc-icons {
  color: #acb4be;
}
.send-btn {
  display: flex;
  justify-content: center;
  align-items: center;
}
.close-btn {
  background: #acb4be;
  color: white;
  border-radius: 50%;
  font-size: 16px;
  padding: 3px;
  position: absolute;
  right: 5px;
  top: 5px;
}
</style>